var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14.5C10.866 14.5 14 11.366 14 7.5C14 3.63401 10.866 0.5 7 0.5C3.13401 0.5 0 3.63401 0 7.5C0 11.366 3.13401 14.5 7 14.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.44704 3.23758C0.897181 3.95297 0.482568 4.77752 0.24115 5.67328H3.88273L1.44704 3.23758Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7591 5.67337C13.5177 4.77765 13.103 3.9531 12.5532 3.2377L10.1176 5.67337H13.7591Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.24115 9.32596C0.482595 10.2217 0.897209 11.0462 1.44704 11.7616L3.88266 9.32596H0.24115Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2615 1.94655C10.5461 1.39669 9.72162 0.982077 8.82587 0.740631V4.38219L11.2615 1.94655Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7381 13.052C3.45349 13.6019 4.27804 14.0165 5.17377 14.2579V10.6164L2.7381 13.052Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17374 0.740631C4.27802 0.982076 3.45347 1.39669 2.7381 1.94652L5.17374 4.38216V0.740631Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82587 14.2579C9.72159 14.0165 10.5461 13.6019 11.2615 13.052L8.82587 10.6164V14.2579Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1176 9.32596L12.5532 11.7616C13.103 11.0463 13.5177 10.2217 13.7591 9.32596H10.1176Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9407 6.58696H7.91309H7.91306V0.559254C7.61417 0.520344 7.30945 0.5 7 0.5C6.6905 0.5 6.38583 0.520344 6.08696 0.559254V6.58691V6.58694H0.0592539C0.0203438 6.88583 0 7.19055 0 7.5C0 7.8095 0.0203438 8.11417 0.0592539 8.41303H6.08691H6.08694V14.4407C6.38583 14.4797 6.6905 14.5 7 14.5C7.30945 14.5 7.61417 14.4797 7.91303 14.4407V8.41309V8.41306H13.9407C13.9797 8.11417 14 7.8095 14 7.5C14 7.19055 13.9797 6.88583 13.9407 6.58696Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82611 9.32657L11.9498 12.4502C12.0934 12.3066 12.2305 12.1565 12.3612 12.0008L9.68695 9.32654H8.82611V9.32657Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1739 9.32654H5.17385L2.05023 12.4502C2.19384 12.5938 2.34399 12.7309 2.49963 12.8616L5.1739 10.1873V9.32654Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17378 5.67365V5.67359L2.05014 2.54993C1.90648 2.69354 1.76943 2.84368 1.63867 2.99932L4.31297 5.67362H5.17378V5.67365Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82611 5.67427L11.9498 2.55057C11.8062 2.40691 11.656 2.26986 11.5004 2.13913L8.82611 4.81343V5.67427V5.67427Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.157fef12ccff37307b186c3e0b055f5c.svg";
export { ForwardRef as ReactComponent };